import { useEffect } from "react";
import { Link } from "react-router-dom";
import useLegacyHomeScripts from "../hooks/useLegacyHomeScripts";

function HomePage() {
  useLegacyHomeScripts();
  useEffect(() => {
    document.title = "Risk Engineering & Management Solutions | PlacedRisk Solutions";
  }, []);

  return (
    <>
      <div id="preloader" />
      <div className="progress-wrap cursor-pointer">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>

      <header className="header slider-fade">
        <div className="owl-carousel owl-theme">
          <div
            className="text-right item bg-img"
            data-overlay-dark="4"
            data-background="/img/slider1.jpg"
          >
            <div className="v-middle caption mt-30">
              <div className="container">
                <div className="row">
                  <div className="col-md-10 offset-md-3">
                    <h1>Property and Casualty Risks One Comprehensive Report</h1>
                    <div className="col-md-9.5 offset-md-4 justify-content-end">
                      <p>
                        Our risk engineering assessments and reporting cover people safety and asset protection, so
                        you get one clear, easy-to-use report covering major property and casualty insurance lines,
                        saving you time and cost.
                      </p>
                    </div>
                    <div className="butn-light mt-30 mb-30">
                      <Link to="/SelfAssessment">
                        <span>Access your complimentary Client Risk Report</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="text-right item bg-img"
            data-overlay-dark="5"
            data-background="/img/slider3.jpg"
          >
            <div className="v-middle caption mt-30">
              <div className="container">
                <div className="row">
                  <div className="col-md-10 offset-md-3">
                    <h1 className="navheading">Tomorrow’s improved risk priced with precision</h1>
                    <div className="col-md-9.5 offset-md-4 justify-content-end">
                      <p>
                        PRS AREA equips every risk engineering report with data analytics so underwriters can price
                        tomorrow’s improved risk.
                      </p>
                    </div>
                    <div className="butn-light mt-30 mb-30">
                      <Link to="/SelfAssessment">
                        <span>Access your complimentary Client Risk Report</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="text-right item bg-img"
            data-overlay-dark="4"
            data-background="/img/slider2.jpg"
          >
            <div className="v-middle caption mt-30">
              <div className="container">
                <div className="row">
                  <div className="col-md-10 offset-md-3">
                    <h1 className="navheading">Trusted Globally</h1>
                    <div className="col-md-9.5 offset-md-4 justify-content-end">
                      <p>
                        PlacedRisk Solutions is a globally recognised independent risk engineering firm, specialising
                        in people safety, asset protection and business continuity.
                        <br />
                        <br />
                        Our assessments, reporting, risk profiling and management services help clients improve
                        their risk profiles, whilst securing competitive insurance premiums via our broking and
                        underwriting partners.
                      </p>
                    </div>
                    <div className="butn-light mt-30 mb-30">
                      <Link to="/SelfAssessment">
                        <span>Access your complimentary Client Risk Report</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-corner" />
        <div className="hero-corner3" />

        <div className="left-panel">
          <ul className="social-left clearfix">
            <li>
              <a
                href="https://www.linkedin.com/company/placedrisk-solutions/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="ti-linkedin" />
              </a>
            </li>
          </ul>
        </div>
      </header>

      <div className="content-wrapper">
        <section className="services section-padding home-area-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12 animate-box" data-animate-effect="fadeInUp">
                <h2 className="section-title">
                  Powered by PRS AREA, <span>Our Analytical Risk Engineering Algorithm</span>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 animate-box" data-animate-effect="fadeInUp">
                <p>
                Developed over two decades in partnership with senior underwriters, portfolio managers and engineers, PRS AREA captures over 1,000 risk engineering data points per assessment, delivering predictive data analytics that equip underwriters to competitively price your risk.. PRS AREA Risk Ratings are
                  provided at no additional cost as part of every PlacedRisk Solutions Risk Engineering Report.
                </p>
              </div>
              <div className="col-md-12 animate-box" data-animate-effect="fadeInUp">
                <picture>
                  <source srcSet="images/RatingChart.jpg" media="(max-width: 600px)" />
                  <source srcSet="images/RatingChart.jpg" media="(max-width: 1500px)" />
                  <img
                    src="images/RatingChart.jpg"
                    alt="PRS AREA Rating Chart"
                    style={{ width: "100%", height: "auto" }}
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>

        <section className="services section-padding home-services-section">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-30 animate-box" data-animate-effect="fadeInUp">
                <h2 className="section-title">
                  Our <span>Services</span>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="services2 mb-60">
                  <Link to="/RiskEngineering">
                    <div className="services2-img">
                      <img src="/Services/PropertyRiskConsulting.jpg" alt="" className="w-100" />
                    </div>
                  </Link>
                  <div className="services2-content">
                    <Link to="/RiskEngineering">
                      <h3 className="services2-title">Risk Engineering</h3>
                    </Link>
                  </div>
                  <div className="title-box">
                    <h3 className="mb-0">Risk Engineering</h3>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="services2 mb-60">
                  <Link to="/Strata">
                    <div className="services2-img">
                      <img
                        src="/Services/ClientRiskImprovementSupport.jpg"
                        alt=""
                        className="w-100"
                      />
                    </div>
                  </Link>
                  <div className="services2-content">
                    <Link to="/Strata">
                      <h3 className="services2-title">Strata</h3>
                    </Link>
                  </div>
                  <div className="title-box">
                    <h3 className="mb-0">Strata</h3>
                  </div>
                </div>
              </div>


                            <div className="col-md-6">
                <div className="services2 mb-60">
                  <Link to="/CrisisManagementandBusinessContinuity">
                    <div className="services2-img">
                      <img src="/Services/PlacementSupport.jpg" alt="" className="w-100" />
                    </div>
                  </Link>
                  <div className="services2-content">
                    <Link to="/CrisisManagementandBusinessContinuity">
                      <h3 className="services2-title">Crisis Management and Business Continuity</h3>
                    </Link>
                  </div>
                  <div className="title-box">
                    <h3 className="mb-0">Crisis Management and Business Continuity</h3>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="services2 mb-60">
                  <Link to="/PortfolioAnalyticsandDataInsights">
                    <div className="services2-img">
                      <img src="/Services/portfolioanalytics.jpg" alt="" className="w-100" />
                    </div>
                  </Link>
                  <div className="services2-content">
                    <Link to="/PortfolioAnalyticsandDataInsights">
                      <h3 className="services2-title">Portfolio Analytics and Data Insights</h3>
                    </Link>
                  </div>
                  <div className="title-box">
                    <h3 className="mb-0">Portfolio Analytics and Data Insights</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default HomePage;
